/**
 * Routes Configuration
 * This file contains the route configuration separate from components
 * to allow for better decoupling and reusability
 */

export const ROOT_PATH = "/app";

export const ROUTES_CONFIG = {
  ORGANIZATIONS: {
    path: "/organizations",
    fullPath: `${ROOT_PATH}/organizations`,
    exact: false,
    icon: "sitemap",
    label: "Organizations",
    labelAbbr: "Orgs",
  },
  USERS: {
    path: "/users",
    fullPath: `${ROOT_PATH}/users`,
    exact: false,
    icon: "users",
    label: "Users",
    labelAbbr: "Users",
  },
  INTEGRATIONS: {
    path: "/integrations",
    fullPath: `${ROOT_PATH}/integrations`,
    exact: false,
    icon: "swap",
    label: "Integrations",
    labelAbbr: "Integrations",
  },
  SEARCH: {
    path: "/search",
    fullPath: `${ROOT_PATH}/search`,
    exact: false,
    icon: "magnifying-glass",
    label: "Search",
    labelAbbr: "Search",
  },
  PROFILE: {
    path: "/profile",
    fullPath: `${ROOT_PATH}/profile`,
    exact: true,
  },
  TEMPLATES: {
    path: "/templates",
    fullPath: `${ROOT_PATH}/templates`,
    exact: false,
    icon: "list",
    label: "Templates",
    labelAbbr: "Templates",
  },
  LIBRARY: {
    path: "/library",
    fullPath: `${ROOT_PATH}/library`,
    exact: false,
    icon: "books",
    label: "Library",
    labelAbbr: "Library",
  },
};
